import { render } from "./FeatureAudit.vue?vue&type=template&id=24e3efac"
import script from "./FeatureAudit.vue?vue&type=script&lang=js"
export * from "./FeatureAudit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__